<!--
  @Description: 直播列表
  @Author: wang.y 
  @Date: 2022-05-31 
-->
<template>
  <div class="live-list">
    <div class="live">
      <div class="list-container">
        <div class="list-name">
          <div class="list-name-l" :class="{'on': scene_type == 1}" @click="handleChangeScene(1)">即将开播</div>
          <div class="list-name-l" :class="{'on': scene_type == 2}" @click="handleChangeScene(2)">直播回放</div>
          <div class="name-line"></div>
        </div>
        <div class="list">
          <div class="list-item" v-for="item,index in livelist" :key="index" :class="{'list-item2': item.aliveState == 2}">
            <div class="list-item-img" @click="getliveurl(item)">
              <div class="list-item-status on" v-if="item.aliveState == 0">
                <i class="iconfont">&#xe6c5;</i>距直播还有 {{diffTime(item.aliveStartAt)}}
              </div>
              <div class="list-item-status on" v-if="item.aliveState == 1">
                <i class="iconfont">&#xe6c3;</i>正在直播
              </div>
              <div class="list-item-status" v-if="item.aliveState == 2">
                <i class="iconfont">&#xe6c4;</i>直播回放
              </div>
              <div class="live-icon">
                <i class="iconfont">&#xe6c6;</i>
              </div>
              <img :src="item.imgUrl">
            </div>
            <div class="list-item-time on" v-if="item.aliveState == 0">直播时间丨{{item.aliveStartAt | time_moment_second}}-{{item.aliveStopAt | time_moment('HH:mm')}}</div>
            <div class="list-item-time on" v-if="item.aliveState == 1">正在直播丨{{item.aliveStartAt | time_moment_second}}-{{item.aliveStopAt | time_moment('HH:mm')}}</div>
            <div class="list-item-time" v-if="item.aliveState == 2">直播回放丨{{item.aliveStartAt | time_moment_second}}-{{item.aliveStopAt | time_moment('HH:mm')}}</div>
            <a class="list-item-name" @click="getliveurl(item)">{{item.title}}</a>
          </div>
        </div>
        <Nothing v-if="livelist.length == 0 && !more_loading" >
          <p>暂无相关信息</p>
        </Nothing>
        <div class="more_div" v-if="is_more"><Button @click="more()" :loading="more_loading" :class="more_loading ? 'more_loading' : ''">{{more_loading ? '加载中' : '加载更多'}}</Button></div>
      </div>
    </div>
  </div>
</template>
<script>

import Nothing from '@/components/Nothing'
import { liveList } from '@/service'
import moment from 'moment'
export default {
  metaInfo() {
    return {
      title: '直播频道-动脉网'
    }
  },
  inject: ['login'],
  components: {Nothing},
  created() {
    this.scene_type = this.$route.query.listtype
    this.getLiveList()
  },
  mounted() {
    this.liveInterval = setInterval(() => {
      this.now_time = moment().unix()
    }, 1000)
  },
  beforeDestroy() {
    clearInterval(this.liveInterval)
    this.liveInterval = ''
  },
  data() {
    return {
      liveInterval: '',
      now_time: '',
      livelist: [],
      page: 1,
      scene_type: 2,
      is_more: true,
      more_loading: true,
    }
  },
  computed: {
    diffTime() {
      let fm = num => num < 10 ? '0' + num : num
      return function (t) {
        let str = moment(t).unix() - this.now_time
        let h = Math.floor(str / 3600),
            d = Math.floor(h / 24),
            h2 = Math.floor(h % 24),
            m = Math.floor((str % 3600) / 60),
            s = (str % 3600) % 60
        let hh = fm(h2),
            mm = fm(m),
            ss = fm(s)
        let dd = d >= 1 ? d + '天' : ''
        return dd + hh + '时' + mm + '分' + ss + '秒'
      }
    },
    user_key() {
      return this.$store.state.user_key
    },
  },
  methods: {
    /**
     * @description: 加载更多
     * @param {*}
     * @return {*}
     */
    more() {
      ++this.page
      this.getLiveList()
    },
    handleChangeScene(index) {
      this.livelist = []
      this.page = 1
      this.scene_type = index
      this.getLiveList()
    },
    async getLiveList() {
      // 即将开播列表
      this.more_loading = true
      let res = await liveList(
        {
          page: this.page,
          pageSize: 12,
          scene: this.scene_type,
        },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )
      this.more_loading = false
      if (res.code == 0) {
        this.livelist = [...this.livelist, ...res.data.list]
        this.is_more = res.data.list.length == 12
      } else {
        this.$Message.error(res.msg)
      }
    },
    getliveurl(item) {
      window.open(item.h5Url)
    },
  },
}
</script>
<style lang='stylus' scoped>
.live-list
  background #fff
  position relative
  >>>.ivu-spin
    color #FF8824
    &.comp-spin
      z-index 10
      .ivu-spin-main
        top 42vh
  .live
    position relative
    width 1140px
    min-height calc(100vh - 64px)
    margin 0 auto
    padding 30px 0
  .list-container
    margin-top 30px
    .list-name
      display flex
      align-items center
      &-l
        font-size 24px
        color #333
        margin-right 20px
        line-height 28px
        cursor pointer
        &:hover
          color #ff8824
        &.on
          font-weight bold
          color #ff8824
      .name-line
        flex 1
        height 1px
        background #EEEEEE
      a.list-more
        width 96px
        height 28px
        background #FF8824
        color #FFFFFF
        display flex
        justify-content center
        align-items center
        margin-left 20px
        cursor pointer
        transition all 0.2s
        &:hover
          background #f60
    .list
      display flex
      padding-top 30px
      flex-wrap wrap
      .list-item
        width 360px
        margin-right 30px
        margin-bottom 30px
        &:nth-of-type(3n)
          margin-right 0
        .list-item-img
          height 216px
          position relative
          overflow hidden
          cursor pointer
          img
            width 100%
            height 100%
            transition all 0.3s
          &:hover
            img
              transform scale(1.1, 1.1)
          .list-item-status
            position absolute
            background #0177EE
            font-size 13px
            display flex
            align-items center
            height 28px
            color #fff
            padding 0 6px
            z-index 2
            &.on
              background #ff8824
            i
              font-size 13px
              margin-right 5px
          .live-icon
            position absolute
            top 50%
            left 50%
            transform translate(-50%, -50%)
            z-index 2
            width 70px
            height 70px
            background rgba(0, 0, 0, 0.6)
            border-radius 50%
            display flex
            align-items center
            justify-content center
            .iconfont
              font-size 28px
              color #fff
        .list-item-time
          margin-top 14px
          line-height 20px
          background #E9F3FF
          color #0177EE
          display inline-block
          vertical-align middle
          padding 0 6px
          &.on
            background-color #FFEFE2
            color #ff8824
        a.list-item-name
          margin-top 14px
          font-size 18px
          font-weight bold
          color #333333
          line-height 28px
          cursor pointer
          display -webkit-box
          overflow hidden
          text-overflow ellipsis
          word-break break-all
          -webkit-box-orient vertical
          -webkit-line-clamp 2
          &:hover
            color #ff8824
      .list-item2
        .list-item-img
          .list-item-status
            background rgba(0, 0, 0, 0.6)
        .list-item-time
          padding 0
          color #666
          background none
          line-height 1
    .more_div
      text-align center
      padding-top 30px
      button
        color #ff8824
        border 1px solid #ff8824
        width 126px
        height 38px
        background-color #fff
        cursor pointer
        border-radius 20px
        &:focus
          box-shadow none
      .more_loading
        border 0
</style>